import { Box } from "@mui/material";
import styled from "styled-components";

export const TimeAdjustmentsStyled = styled(Box)`
  height: 100%;
  .no-entry {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: auto 0;
    gap: 8px;
  }
  .time-card-wrapper {
    display: flex;
    flex-direction: column;
    gap: 24px;
    .card-wrapper {
      padding: 24px;
      border-radius: 20px;
      row-gap: 24px;

      .content-wrapper {
        display: flex;
        flex-direction: column;
        @media (max-width: 768px) {
          row-gap: 24px;
        }

        .fields-wrapper {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 24px;
          @media (max-width: 1024px) {
            grid-template-columns: 1fr 1fr;
          }

          @media (max-width: 768px) {
            grid-template-columns: 1fr;
            row-gap: 24px;
          }
          .input-pair {
            display: flex;
            flex-direction: column;
            background-color: #fff;
            gap: 20px;
            padding: 16px;
            border-radius: 10px;
            height: 304px;
            overflow: auto;
            .entry-row {
              display: grid;
              grid-template-columns: 1fr 1fr auto;
              align-items: center;
              gap: 16px;
            }
          }
        }

        .button-row {
          display: flex;
          gap: 8px;
          margin-top: 8px;
        }

        .button-wrapper {
          align-self: flex-end;
          margin-top: 8px;
          @media (max-width: 768px) {
            align-self: center;
            width: 100%;
          }
        }
      }
    }
  }
`;

export const StyledInfoBox = styled(Box)`
  padding: 10px; // Add padding
  border-radius: 5px; // Rounded corners
  margin-top: 10px; // Add spacing from the title

  p {
    font-weight: normal; // Make the text non-bold
    color: #666; // Optional: Adjust text color for better readability
    margin: 0;
  }
`;
